export enum PropertyType {
  Commercial = 0,
  Residential = 1,
}
